import { NumberParam, StringParam, useQueryParam, withDefault } from 'use-query-params';
import { NoddiPaginationState } from '../../../..';

const paginationQueryParamKeys = {
  page: 'page',
  pageSize: 'page-size',
  search: 'search'
} as const;

interface Params {
  initialPage?: number;
  initialPageSize?: number;
  initialSearch?: string;
}

export function usePaginationQueryParam(params?: Params) {
  const { initialPage = 0, initialPageSize = 10, initialSearch = '' } = params ?? {};

  const [pageIndex, setPageIndex] = useQueryParam(paginationQueryParamKeys.page, withDefault(NumberParam, initialPage));
  const [pageSize, setPageSize] = useQueryParam(
    paginationQueryParamKeys.pageSize,
    withDefault(NumberParam, initialPageSize)
  );
  const [search, setSearch] = useQueryParam(paginationQueryParamKeys.search, withDefault(StringParam, initialSearch));

  // Custom pageSize setter that also resets page to initial value
  const handleSetPageSize = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPageIndex(initialPage);
  };

  // Custom search setter that also resets page to initial value
  const handleSetSearch = (newSearch: string) => {
    setSearch(newSearch);
    setPageIndex(initialPage);
  };

  const setPagination = (pagination: NoddiPaginationState) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setSearch(pagination.search);
  };

  return {
    pageIndex,
    setPage: setPageIndex,
    pageSize,
    setPageSize: handleSetPageSize,
    search,
    setSearch: handleSetSearch,
    paginationQueryParamKeys,
    pagination: { pageIndex, pageSize, search },
    setPagination
  };
}
